export const COLLECTION_EXAM_MODULE = 'examModules';
